import { config as e2config } from './E2.config';
import { config as e3config } from './E3.config';

let config;
if (
    window?.location?.href?.includes('.qa') ||
    window.location.href.includes('localhost') ||
    window.location.href.includes('127.0.0.1')
  ) {
    config = e2config;
  } else {
    config = e3config;
  }

// Now use `config` in your dnsservices logic
export { config };